function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "bandcamp");

var _ref2 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "st0",
  points: "0,18.8 0,24 24,24 24,5.2 16.6,18.8 "
});

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "st0",
  points: "0,0 0,18.8 7.4,5.2 24,5.2 24,0 "
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      "enableBackground": "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/bandcamp.59064b06.svg";
export { SvgComponent as ReactComponent };